import { GAevent } from "../utils/meetbaar";

let fired = {
  25: false,
  50: false,
  75: false,
  100: false,
};

export const initScrollTracking = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("scroll", () => {
    const scrollPercent =
      (window.scrollY + window.innerHeight) /
      document.body.scrollHeight;

    const percent = Math.round(scrollPercent * 100);

    [25, 50, 75, 100].forEach((p) => {
      if (percent >= p && !fired[p]) {
        fired[p] = true;

        GAevent("scroll_depth", {
          percent: p,
          page_path: window.location.pathname,
        });
      }
    });
  });
};